<template>
  <aside>
    <h6>Help Docs <i class="fas fa-question-circle light-blue-text small" /></h6>
    <article class="collection">
        <a class="collection-item" href="https://docs.google.com/document/d/1D8nks_SmViFCjPiGO67Trh0ifG1G0ztkpJ4nSRtXF3E/view?usp=sharing" target="_blank">
          TMF Real Money Portfolio: Implementation Guidelines
        </a>
    </article>
  </aside>
</template>

<script>
export default {
  name: 'Help',
  props: {},
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '@/main.scss';

.wrapper {
  border: 1px solid $tmf-gains;
  border-radius: 10px;
  padding: 0px 15px 0px 15px;
}
</style>
